module.exports = __webpack_public_path__ + "img/fconnect4.1d89cbcd.jpg";